import { UserRole } from '@maru/libcore/gen/project_types_pb'

/**
 * The current user's role within the project.
 *
 * Values mirror the `project.UserRole` proto enum returned by core's
 * `GetProjectById` (`NOT_MEMBER=0, LEAD=1, OBSERVER=2, PARTICIPANT=3`) — the
 * same authoritative project data the SPA already reads over the main-app
 * bridge. We deliberately do NOT derive the role from the survey session
 * response variables.
 */
export enum ProjectUserRole {
  NotMember = 'not_member',
  Lead = 'lead',
  Observer = 'observer',
  Participant = 'participant',
}

/** Map the numeric proto `UserRole` value (or a string) onto a {@link ProjectUserRole}. */
export function normaliseProjectUserRole(value: unknown): ProjectUserRole {
  switch (value) {
    case UserRole.LEAD:
    case ProjectUserRole.Lead:
      return ProjectUserRole.Lead
    case UserRole.PARTICIPANT:
    case ProjectUserRole.Participant:
      return ProjectUserRole.Participant
    case UserRole.OBSERVER:
    case ProjectUserRole.Observer:
      return ProjectUserRole.Observer
    default:
      // Default to the most restrictive role so access is never granted by
      // accident when the role is missing or unrecognised.
      return ProjectUserRole.NotMember
  }
}


